import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/publicationSpecialDeadline/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/publicationSpecialDeadline/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/publicationSpecialDeadline/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/publicationSpecialDeadline/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/publicationSpecialDeadline/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/publicationSpecialDeadline/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators

export function deletePublicationSpecialDeadline(deadline, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/publications/${deadline.publication_id}/special_deadlines/${deadline.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const state = getState()

        // Remove the special deadline from the publication
        const publicationEntity = Object.assign({}, state.entities.publications[deadline.publication_id])
        const specialDeadlineIndex = publicationEntity.special_deadlines.indexOf(deadline.id)
        publicationEntity.special_deadlines.splice(specialDeadlineIndex, 1)
        dispatch(updateEntities(normalize(publicationEntity, Schemas.PUBLICATION)))

        // Remove the deadline to the result array
        const publicationSpecialDeadlineArray = state.publicationSpecialDeadlines.result ? state.publicationSpecialDeadlines.result.slice() : []
        const index = publicationSpecialDeadlineArray.indexOf(deadline.id)
        const x = normalize(deadline, Schemas.PUBLICATION_SPECIAL_DEADLINE)
        dispatch(deleteEntity(x))

        // Remove the entity
        if (index != -1){
          publicationSpecialDeadlineArray.splice(index, 1)
          dispatch(deleteSuccess({ result: publicationSpecialDeadlineArray }))
        }
      })
      .catch((json) => {
        const errors = json.errors ? json.errors : ['Something went wrong']
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function createPublicationSpecialDeadline(deadline, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      publication_special_deadline: deadline,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/publications/${deadline.publication_id}/special_deadlines.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().publicationSpecialDeadlines.result ? getState().publicationSpecialDeadlines.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }
        const normalizedJson = normalize(json, Schemas.PUBLICATION_SPECIAL_DEADLINE)
        const publications = Object.assign({}, getState().entities.publications)
        if (publications[deadline.publication_id]){
          const publication = publications[deadline.publication_id]
          publication.special_deadlines.push(json.id)
          dispatch(updateEntities(normalize(publication, Schemas.PUBLICATION)))
        }
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
